module.exports = __webpack_public_path__ + "media/images/favicon-6d05217c30ee11806109bb2781169783.png";